import { render, staticRenderFns } from "./TicketActions.vue?vue&type=template&id=5dd64fce&scoped=true&"
import script from "./TicketActions.vue?vue&type=script&lang=js&"
export * from "./TicketActions.vue?vue&type=script&lang=js&"
import style0 from "./TicketActions.vue?vue&type=style&index=0&id=5dd64fce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd64fce",
  null
  
)

export default component.exports